/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    DeviceConfigurationResponse,
    DeviceConnectionInfoResponse,
    UpdateDefaultRfidTagRequest,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    DeviceConfigurationResponseFromJSON,
    DeviceConfigurationResponseToJSON,
    DeviceConnectionInfoResponseFromJSON,
    DeviceConnectionInfoResponseToJSON,
    UpdateDefaultRfidTagRequestFromJSON,
    UpdateDefaultRfidTagRequestToJSON,
} from "../models/index";

export interface DeviceConfigurationGetRequest {
    deviceIdentity: string;
}

export interface DeviceConnectionInfoGetRequest {
    deviceIdentity: string;
}

export interface DeviceDefaultRfidTagGetRequest {
    deviceIdentity: string;
}

export interface DeviceDefaultRfidTagUpdateRequest {
    deviceIdentity: string;
    body?: UpdateDefaultRfidTagRequest;
}

/**
 *
 */
export class DeviceConfigurationHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Device configuration. Use CategoriesToKeys to group configs, eg \'electricalSolarOnly\' for Solar Link only config
     */
    async deviceConfigurationGetRaw(
        requestParameters: DeviceConfigurationGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceConfigurationResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceConfigurationGet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/configuration`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceConfigurationResponseFromJSON(jsonValue),
        );
    }

    /**
     * Device configuration. Use CategoriesToKeys to group configs, eg \'electricalSolarOnly\' for Solar Link only config
     */
    async deviceConfigurationGet(
        requestParameters: DeviceConfigurationGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceConfigurationResponse> {
        const response = await this.deviceConfigurationGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Device connection info, including Ethernet/Wifi mac addresses etc
     */
    async deviceConnectionInfoGetRaw(
        requestParameters: DeviceConnectionInfoGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceConnectionInfoResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceConnectionInfoGet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/connection`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceConnectionInfoResponseFromJSON(jsonValue),
        );
    }

    /**
     * Device connection info, including Ethernet/Wifi mac addresses etc
     */
    async deviceConnectionInfoGet(
        requestParameters: DeviceConnectionInfoGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceConnectionInfoResponse> {
        const response = await this.deviceConnectionInfoGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the default RFID tag configuration for a device. Value returned in IdentityStr. Returns error if device does not support this feature.
     */
    async deviceDefaultRfidTagGetRaw(
        requestParameters: DeviceDefaultRfidTagGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceDefaultRfidTagGet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/configuration/default-rfid-tag`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Get the default RFID tag configuration for a device. Value returned in IdentityStr. Returns error if device does not support this feature.
     */
    async deviceDefaultRfidTagGet(
        requestParameters: DeviceDefaultRfidTagGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceDefaultRfidTagGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update the default RFID tag configuration for a device
     */
    async deviceDefaultRfidTagUpdateRaw(
        requestParameters: DeviceDefaultRfidTagUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceDefaultRfidTagUpdate().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/configuration/default-rfid-tag`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PATCH",
                headers: headerParameters,
                query: queryParameters,
                body: UpdateDefaultRfidTagRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update the default RFID tag configuration for a device
     */
    async deviceDefaultRfidTagUpdate(
        requestParameters: DeviceDefaultRfidTagUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceDefaultRfidTagUpdateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
